// © 2015-2021 WDNA - All Rights Reserved
import { combineReducers, Reducer } from 'redux';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';

import layoutReducer, { RxState as LayoutState } from 'wdna-components/lib/layout/reducer';
import navigationReducer, { RxState as NavigationState } from 'wdna-components/lib/navigation/reducer';
import mainFilterReducer, { RxState as MainFilterState } from 'wdna-components/lib/mainfilter/reducer';
import sidebarReducer, { RxState as SidebarState } from 'wdna-components/lib/sidebar/reducer';
import schedulerReducer, { RxState as SchedulerState } from 'wdna-components/lib/scheduler/reducer';
import tabsReducer, { RxState as TabsState } from 'wdna-components/lib/tabs/reducer';

import authReducer, { RxState as AuthState } from '../services/auth/reducer';

import keplerReducer from './keplerReducer';

const rootReducer = (history: History): Reducer => {
  return combineReducers({
    auth: authReducer,
    keplerGl: keplerReducer,
    layout: layoutReducer,
    mainFilter: mainFilterReducer,
    navigation: navigationReducer,
    scheduler: schedulerReducer,
    sidebar: sidebarReducer,
    tabs: tabsReducer,
    router: connectRouter(history),
  });
};

export default rootReducer;

export type RootState = {
  // External
  layout: LayoutState;
  navigation: NavigationState;
  mainfilter: MainFilterState;
  scheduler: SchedulerState;
  sidebar: SidebarState;
  tabs: TabsState;
  // Internal
  auth: AuthState;
};
